import {Editor} from '@tiptap/react';
import {memoize} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../../shared/helpers/src/internationalization/react';
import {lightTheme} from '../../../../../../shared/ui/src/theme/light/lightTheme';
import {UserTheme, useUserTheme} from '../../../../../../shared/ui/src/theme/userThemeProvider';
import {ColorPickerBox} from './colorPickerBox';

/*
 * Props.
 */

interface FontColorDropdownProps {
  editor: Editor;
}

/*
 * Component.
 */

export const FontColorDropdown: FC<FontColorDropdownProps> = ({editor}) => {
  const theme = useUserTheme();

  return (
    <ColorPickerBox
      selectedColor={editor.getAttributes('textStyle').color}
      onColorSelect={(color) => {
        if (!color) {
          return editor.chain().focus().unsetColor().run();
        }
        return editor.chain().focus().setColor(color).run();
      }}
      tooltip={<Trans id="knowledge-base-tool-font-color">Font color</Trans>}
      iconName="formattingColor"
      colors={computeColors(theme)}
    />
  );
};

/*
 * Helpers.
 */

const computeColors = memoize((theme: UserTheme) => [
  [
    {color: lightTheme.palette.blue.shade40, lightForeground: true},
    {color: lightTheme.palette.teal.shade40, lightForeground: true},
    {color: lightTheme.palette.green.shade40, lightForeground: true},
    {color: lightTheme.palette.yellow.shade40, lightForeground: true},
    {color: lightTheme.palette.orange.shade40, lightForeground: true},
  ],
  [
    {color: lightTheme.palette.red.shade40, lightForeground: true},
    {color: lightTheme.palette.pink.shade40, lightForeground: true},
    {color: lightTheme.palette.purple.shade40, lightForeground: true},
    {color: lightTheme.greys.shade90, lightForeground: true},
    {color: '#fff', borderColor: theme.greys.shade40, selectedBorderColor: theme.greys.shade70},
  ],
]);
